// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchMapInfoCard_root__rqq8X"};